





































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import eventsCard from "@/components/Events/eventsCard.vue";
import { isBefore, startOfToday } from "date-fns";
import CodeMessage from "@/components/CodeMessage.vue";

@Component({
    components: {
        eventsCard,
        CodeMessage
    }
})
export default class MyEvents extends Vue {
    public isUpcoming: boolean = true;
    public activeS: string = "all";
    public eventsName: string = "ALL";
    public events: any = {
        upcoming: [],
        past: []
    };
    public showSpinner: boolean = false;
    public totalUpEvents: number = 0;
    public totalPastEvents: number = 0;
    public currentUpPage: number = 1;
    public currentPastPage: number = 1;
    public pastFlag: boolean = false;
    public debug: any = "";

    public activeEvents(eventsName) {
        this.eventsName = eventsName.toUpperCase();
        this.activeS =
            eventsName === "all"
                ? eventsName
                : eventsName.substring(0, eventsName.length - 1);
        this.getReservations(this.isUpcoming ? "upcoming" : "past", 1);
    }

    async mounted() {
        this.getReservations("upcoming", 1);
    }

    async getReservations(when, page) {
        this.showSpinner = true;
        const query: any = await this.$reservationApi.reservationsList(
            this.activeS,
            when === "upcoming" ? 1 : 0,
            page,
            6
        );
        if (page === 1) {
            this.events[when] = query.data;
        } else {
            this.events[when].push(...query.data);
        }
        if (when === "upcoming") {
            this.totalUpEvents = query.total;
        } else {
            this.totalPastEvents = query.total;
        }
        this.showSpinner = false;
    }

    get profile() {
        return this.$store.getters.profile;
    }

    @Watch("isUpcoming")
    onIsUpcomingChange(val) {
        this.activeS = "all";
        this.eventsName = "ALL";
        if (!this.pastFlag) {
            this.getReservations("past", 1);
            this.pastFlag = true;
        }
    }
}
